export default __webpack_public_path__ + "static/media/authorizationIconEmpty.3b823c1b.svg";